module.exports = __webpack_public_path__ + "static/img_2444-06eed267a555eb07b215d6ffc14fc111.webp";